<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card class="pb-5">
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reSchedule()"
        >
          <v-row justify="center" no-gutters>
            <v-alert
              v-model="alert"
              color="#fdf0d7"
              dense
              type="info"
              class="text-center black--text caption mb-0"
              dismissible
              >{{ $t("rescheduleformtextalert") }}</v-alert
            >
          </v-row>
          <v-card-text>
            <div align="center" class="pt-2">
              <p>{{ $t("schedule_interview") }}</p>
            </div>

            <v-row>
              <v-col cols="12">
                <candidate-custom-combobox @change="setCandidates" />
              </v-col>
              <v-col cols="12">
                <recruter-combobox
                  :existingRecruters="recruters"
                  :existingObservers="observers"
                  :isObserver="false"
                  @change="changeRecruters"
                />
              </v-col>
              <v-col cols="12">
                <recruter-combobox
                  :existingRecruters="recruters"
                  :existingObservers="observers"
                  :isObserver="true"
                  @change="changeObservers"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="interview.subject"
                  :label="$t('subject')"
                  dense
                  outlined
                  hide-details
                  :rules="requiredRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <date-picker @input="setDate" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="time"
                  :label="$t('interview_time')"
                  v-mask="'##:##'"
                  placeholder="00:00"
                  prepend-inner-icon="access_time"
                  dense
                  outlined
                  hide-details
                  :rules="requiredRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="interview.address"
                  :label="$t('phisic_adress')"
                  dense
                  prepend-inner-icon="place"
                  outlined
                  hide-details
                  :rules="requiredRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="interview.telephone"
                  :label="$t('Institution_telephone')"
                  dense
                  prepend-inner-icon="mdi-phone"
                  outlined
                  hide-details
                  :rules="requiredRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="interview.message"
                  rows="3"
                  :autocomplete="$t('enter_message')"
                  :label="$t('enter_message')"
                  :hint="$t('interviewCreateSuccesshint')"
                  persistent-hint
                  dense
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="close()" color="primary">
              {{ $t("finish") }}
            </v-btn>
            <v-btn
              class="mr-4 px-6"
              color="primary"
              type="submit"
              :loading="isLoading"
            >
              {{ $t("send") }}
            </v-btn>
            <v-btn
              absolute
              top=""
              right=""
              icon=""
              class="mt-5"
              @click="$emit('close')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
    <error-dialog
      :dialog="showError"
      :message="error"
      @close="showError = false"
    />
  </v-dialog>
</template>

<script>
import { API_URL } from "@/api";
import { ADD_CANDIDATE_TO_INTERVIEW_MUTATION } from "../../graphql/Mutation.gql";
import { ADD_DIALOG } from "@/mixins/dialog";
import { formatErrors } from "@/utils";
import ErrorDialog from "../../../../components/ErrorDialog.vue";
import CandidateCustomCombobox from "./CandidateCustomCombobox.vue";
import RecruterCombobox from "./RecruterCombobox.vue";
import DatePicker from "./DatePicker.vue";
export default {
  name: "AddCandidateToInterview",

  components: {
    CandidateCustomCombobox,
    RecruterCombobox,
    DatePicker,
    ErrorDialog,
  },

  mixins: [ADD_DIALOG],

  data: () => ({
    apiUrl: API_URL,
    alert: true,
    dialog: false,
    candidateEmails: [],
    candidacies: [],
    interviews: [],
    recruters: [],
    observers: [],
    subject: "",
    date: null,
    time: null,
    address: "",
    telephone: "",
    message: "",
    stage: "",
    interviewId: null,
    isCurrentStage: true,
    vacancy: "",
    client: null,
    clients: [],
    valid: true,
    interview: {},
    showError: false,
  }),

  created() {
    // eslint-disable-next-line no-undef
    Fire.$on("AddCandidateToInterview", (interview) => {
      this.interview = interview;
      this.dialog = true;
    });
  },

  computed: {
    requiredRules() {
      return [(v) => !!v || this.$t("form_user_valid")];
    },
  },

  methods: {
    async reSchedule() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        const recruters = this.getRecruterIds();
        const observers = this.getObserverIds();
        try {
          const { data } = await this.$apollo.mutate({
            mutation: ADD_CANDIDATE_TO_INTERVIEW_MUTATION,
            variables: {
              interviewInput: {
                id: this.interview.id,
                address: this.interview.address,
                candidateEmails: this.candidateEmails,
                date: this.date,
                message: this.interview.message,
                observers,
                recruters,
                subject: this.interview.subject,
                telephone: this.interview.telephone,
                time: this.time,
                vacancy: this.interview.vacancy.id,
              },
            },
          });

          this.$emit("added", data.addCandidateToInterview.candidates);
          let successMsg = this.$t("interviewSuccess");
          // eslint-disable-next-line no-undef
          Fire.$emit("SuccessDialog", successMsg);
          this.dialog = false;
        } catch (error) {
          console.log(error);
          // console.log({ format: error.message.split(":")[3].split(",")[0] });

          this.error = formatErrors(error.message);

          this.interview.recruters = undefined;
          this.interview.observers = undefined;
          this.showError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },

    getRecruterIds() {
      return this.recruters.map((mapRecruter) => mapRecruter.id);
    },

    getObserverIds() {
      return this.observers.map((mapObserver) => mapObserver.id);
    },

    setCandidates(candidateEmails) {
      this.candidateEmails = candidateEmails;
    },

    close() {
      this.dialog = false;
    },

    changeRecruters(recruters) {
      this.recruters = recruters;
    },

    changeObservers(observers) {
      this.observers = observers;
    },

    setDate(date) {
      this.date = date;
    },

    setDefault(interviews, stage) {
      const FIRST_ELEMENT = 0;
      const FIRST_INTERVIEW = this.interviews[FIRST_ELEMENT];

      const findedStageIndex = FIRST_INTERVIEW.stages.findIndex(
        (findStage) => findStage.name === stage
      );
      this.recruters = FIRST_INTERVIEW.stages[findedStageIndex].recruters.map(
        (mapRecruter) => mapRecruter.user
      );

      this.observers = FIRST_INTERVIEW.stages[findedStageIndex].observers.map(
        (mapObserver) => mapObserver.user
      );

      this.subject = FIRST_INTERVIEW.subject;
      this.telephone = FIRST_INTERVIEW.telephone;
      this.address = FIRST_INTERVIEW.address;
      this.message = FIRST_INTERVIEW.message;
    },
  },
};
</script>
